import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { LoadingState, PageHeader, Section } from '../components/public/ui';

const History = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistoryData = async () => {
      try {
        const response = await api.get('/public/history');
        setPageData(response.data.data);
      } catch (error) {
        console.error('Error fetching history data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchHistoryData();
  }, []);

  if (loading) return <LoadingState />;

  return (
    <Section className="section-pad !max-w-3xl">
      <PageHeader title={pageData?.title || 'Nuestra historia'} />

      <article className="space-y-10 text-base leading-relaxed text-ink md:text-lg">
        <p className="text-muted">
          {pageData?.content ||
            'Team Kitsune nace con la visión de formar no solo atletas, sino personas con valores, disciplina y respeto. Nuestro equipo de instructores cuenta con amplia experiencia nacional e internacional en Kickboxing y artes marciales.'}
        </p>

        <section>
          <h2 className="font-display text-2xl font-semibold uppercase tracking-wide">
            Nuestra misión
          </h2>
          <p className="mt-3 text-muted">
            Brindar entrenamiento de calidad en Kickboxing, promoviendo el desarrollo físico,
            mental y espiritual de nuestros alumnos en un ambiente de respeto y compañerismo.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-semibold uppercase tracking-wide">
            Nuestra visión
          </h2>
          <p className="mt-3 text-muted">
            Ser reconocidos como una de las escuelas de Kickboxing más destacadas de Argentina,
            formando atletas de alto nivel y personas comprometidas con los valores del deporte.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-semibold uppercase tracking-wide">Valores</h2>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2">
            {['Disciplina', 'Respeto', 'Perseverancia', 'Trabajo en equipo', 'Humildad'].map(
              (value) => (
                <li
                  key={value}
                  className="border-l-4 border-primary bg-surface px-4 py-3 text-sm font-medium"
                >
                  {value}
                </li>
              )
            )}
          </ul>
        </section>
      </article>
    </Section>
  );
};

export default History;
